<template>
	<div v-if="!hasKrs" class="mb-4">
		<v-card class="mb-3"
			color="grey lighten-1"
			justify-center>
			<br>

			<div class="text-xs-center mt-3 mb-5">
				<h2>Podaj dane formalno-prawne</h2>
			</div>

			<div>
				<v-container grid-list-md text-xs-center>
					<v-layout row wrap justify-center>
						<v-flex xs3>
						</v-flex>
						<v-flex xs6>
							<v-text-field
								browser-autocomplete="off"
								label="Nazwa rejestru identyfikującego podmiot"
								aria-label="label for register type"
								for="step-formal-data-component-number-type"
								id="step-formal-data-component-number-type"
								v-model="stepData.numberType"
								class="text-xs-center"
								hint="Upewnij się, że nazwa jest poprawna. Po dokonaniu rejestracji nie ma możliwości edycji nazwy."
								outline>
							</v-text-field>
						</v-flex>
						<v-flex xs3>
						</v-flex>
						<v-flex xs3></v-flex>
						<v-flex xs6>
							<v-text-field
								browser-autocomplete="off"
								label="Numer w rejestrze"
								aria-label="label for register number"
								for="step-formal-data-component-number-in-register"
								id="step-formal-data-component-number-in-register"
								v-model="stepData.number"
								class="text-xs-center"
								hint="Upewnij się, że numer jest poprawny. Po dokonaniu rejestracji nie ma możliwości edycji numeru."
								outline>
							</v-text-field>
						</v-flex>
						<v-flex xs3>
						</v-flex>
					</v-layout>
				</v-container>
			</div>
		</v-card>
		<v-btn color="blue"
			@click="$emit('step', 3)">
			Wstecz
		</v-btn>
		<v-btn
			color="primary"
			@click="$emit('step', 5, 'scope4')">
			Dalej
		</v-btn>
	</div>
	<div v-else class="mb-4">
		<v-card class="mb-3"
			color="grey lighten-1"
			justify-center>
			<br>

			<div class="text-xs-center mt-3 mb-5">
				<h2>Podaj dane formalno-prawne</h2>
			</div>

			<div>
				<v-container grid-list-md text-xs-center>
					<v-layout row wrap justify-center>
						<v-flex xs3></v-flex>
						<v-flex xs6>
							<v-text-field
								browser-autocomplete="off"
								data-vv-name="krs"
								data-vv-as="Numer KRS"
								:error-messages="vErrors.collect('scope4.krs')"
								label="Numer KRS *"
								aria-label="krs number"
								for="step-formal-data-component-numer-krs"
								id="step-formal-data-component-number-krs"
								v-model="stepData.krs"
								v-validate="'required|numeric'"
								data-vv-scope="scope4"
								class="text-xs-center"
								outline>
							</v-text-field>
						</v-flex>
						<v-flex xs3>
						</v-flex>
					</v-layout>
				</v-container>
			</div>
		</v-card>
		<v-btn color="blue"
			@click="$emit('step', 3)">
			Wstecz
		</v-btn>
		<v-btn
			color="primary"
			@click="$emit('step', 5, 'scope4')">
			Dalej
		</v-btn>
	</div>
</template>

<script>
	export default {
		name: "StepFormalDataComponent",
		inject: ["parentValidator"],

		props: {
			stepData: Object,
			hasKrs: Boolean,
		},

		created() {
			this.$validator = this.parentValidator;
		},

		data() {
			return {};
		},
	};
</script>

<style scoped>

</style>
